var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#13AFA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6818 23.8169L26.6782 25.0066L26.0645 26.1034L23.4545 24.5509V21.4375H24.6818V23.8169ZM30 23.9688C30 27.2341 27.4391 29.875 24.2727 29.875C21.1064 29.875 18.5455 27.2341 18.5455 23.9688C18.5455 23.6819 18.57 23.4034 18.6109 23.125H12V13H26.7273V18.6363C28.6582 19.5897 30 21.6147 30 23.9688ZM19.1018 21.4375C19.2491 21.1337 19.4045 20.8469 19.5927 20.5684C19.5191 20.5938 19.4455 20.5938 19.3636 20.5938C18.0055 20.5938 16.9091 19.4631 16.9091 18.0625C16.9091 16.6619 18.0055 15.5312 19.3636 15.5312C20.7218 15.5312 21.8182 16.6619 21.8182 18.0625C21.8182 18.2734 21.7855 18.4844 21.7364 18.6784C22.5055 18.2903 23.3645 18.0625 24.2727 18.0625C24.5509 18.0625 24.8209 18.0878 25.0909 18.13V16.375C24.6569 16.375 24.2407 16.1972 23.9338 15.8807C23.6269 15.5643 23.4545 15.1351 23.4545 14.6875H15.2727C15.2727 15.6241 14.5445 16.375 13.6364 16.375V19.75C14.0704 19.75 14.4866 19.9278 14.7934 20.2443C15.1003 20.5607 15.2727 20.9899 15.2727 21.4375H19.1018ZM28.3636 23.9688C28.3636 21.64 26.5309 19.75 24.2727 19.75C22.0145 19.75 20.1818 21.64 20.1818 23.9688C20.1818 26.2975 22.0145 28.1875 24.2727 28.1875C26.5309 28.1875 28.3636 26.2975 28.3636 23.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalVoucherIcon);
export default __webpack_public_path__ + "static/media/modal-voucher-icon.929995470f619736e271dee5fe3f6b4b.svg";
export { ForwardRef as ReactComponent };